var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataStatus)?_c('v-icon',{staticClass:"icon",attrs:{"size":_vm.size,"color":_vm.dataStatus.color}},[_vm._v(" "+_vm._s(_vm.dataStatus.iconName)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }